import React, { PropsWithChildren, useMemo } from 'react';
import { Matrix4 } from 'three';

import { LAYOUT_TO_DESIGN_COORDINATES_MATRIX, markMatrixWorldDirty } from './coordinates';

const elevationMatrix = new Matrix4();

/**
 * A wrapper for visuals designed to work in design coordinates to make them appear and work correctly in layout mode.
 */
export function LayoutCoordinateVisuals(props: PropsWithChildren<{ elevation?: number }>) {
  const matrix = useMemo(() => {
    const result = LAYOUT_TO_DESIGN_COORDINATES_MATRIX.clone();

    if (props.elevation != null) {
      result.multiply(elevationMatrix.makeTranslation(0, 0, props.elevation));
    }

    return result;
  }, [props.elevation]);

  return (
    <group matrix={matrix} matrixAutoUpdate={false} onUpdate={markMatrixWorldDirty}>
      {props.children}
    </group>
  );
}
